import { compose, merge } from 'lodash/fp';

import commonTheme from '@portal/common/theme/theme-config';

export default compose(merge(commonTheme))({
    // local overrides
});
